var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _g3, _path18, _path19, _path20, _path21, _path22, _path23, _g4, _path24, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg5MetuaaGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 51,
    viewBox: "0 0 72 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3283_2562)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.904 45.6757H61.0491V48.5429H71.904V45.6757Z",
    fill: "url(#paint0_linear_3283_2562)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3853 45.6757H7.08628V48.5429H61.3853V45.6757Z",
    fill: "#1D0C17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.0959473 48.538H7.976V45.6708H-0.0959473V48.538Z",
    fill: "url(#paint1_linear_3283_2562)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2232 20.9921H58.4895C58.4895 20.9921 59.8821 22.1994 59.9773 22.5852C60.0725 22.9709 59.9272 24.3736 59.9272 24.3736L55.8895 23.8426L55.2182 20.9921H55.2232Z",
    fill: "#A1989B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.917 41.513H7.95568C4.37882 41.513 1.33298 38.1465 1.33298 34.5697L1.48327 27.8217H39.917V41.508V41.513Z",
    fill: "#1D0C17"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3032 30.0458H32.1733C30.3198 30.0458 28.8219 33.7129 28.8219 38.2315C28.8219 42.7502 30.3248 46.4172 32.1733 46.4172H37.3032C39.1567 46.4172 40.6546 42.7502 40.6546 38.2315C40.6546 33.7129 39.1517 30.0458 37.3032 30.0458Z",
    fill: "#1D0C17"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8981 30.0458H60.4326C58.4588 30.0458 56.8607 33.7129 56.8607 38.2315C56.8607 42.7502 58.4588 46.4172 60.4326 46.4172H65.8981C67.8719 46.4172 69.4699 42.7502 69.4699 38.2315C69.4699 33.7129 67.8719 30.0458 65.8981 30.0458Z",
    fill: "#1D0C17"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4117 30.0458H5.28185C3.42829 30.0458 1.93042 33.7129 1.93042 38.2315C1.93042 42.7502 3.4333 46.4172 5.28185 46.4172H10.4117C12.2652 46.4172 13.7631 42.7502 13.7631 38.2315C13.7631 33.7129 12.2602 30.0458 10.4117 30.0458Z",
    fill: "#1D0C17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7634 30.0458H29.298C27.3242 30.0458 25.7261 33.7129 25.7261 38.2315C25.7261 42.7502 27.3242 46.4172 29.298 46.4172H34.7634C36.7372 46.4172 38.3353 42.7502 38.3353 38.2315C38.3353 33.7129 36.7372 30.0458 34.7634 30.0458Z",
    fill: "#1D0C17"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34741 13.7197V13.7245C8.34706 13.725 8.34592 13.7258 8.34448 13.7275H22.9714L26.4353 15.6874L31.1697 22.3896L48.2722 24.5195L48.3523 41.6064L48.3474 41.5966L33.6677 41.9365C33.6677 41.9365 33.7617 37.9521 33.4499 34.8036C33.1382 31.6555 31.8445 29.6291 28.8054 29.6913C25.766 29.7537 24.7217 32.248 24.4412 34.2431C24.1606 36.2382 24.5343 39.1685 24.6902 40.6152C24.6601 40.6152 12.2647 40.6298 11.0212 40.6298C9.77886 40.6298 8.82121 40.3616 8.77612 38.9189C8.73604 37.6765 8.66186 35.6503 8.27612 33.8769C7.8904 32.1136 7.12369 29.7492 4.33374 29.749C1.65861 29.8241 1.03668 31.6027 1.6228 36.497C0.891564 35.921 0.717857 35.6613 0.468502 34.9911C0.220524 34.3247 0.0495257 31.9013 0.0476038 31.874C0.0476038 31.398 0.646237 31.0165 0.646237 31.0165L-0.0647009 22.8954C-0.109677 22.3646 0.019828 21.8286 0.310299 21.3779C1.06774 20.2056 2.60786 17.824 3.57495 16.3779C3.8255 15.939 3.93886 15.505 3.43823 15.2021C2.60498 14.6979 2.65187 13.7197 3.0476 13.7197H8.34741Z",
    fill: "#B9B2B4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3283_2562",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 13,
    width: 50,
    height: 29
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34741 13.7197V13.7245C8.34706 13.725 8.34592 13.7258 8.34448 13.7275H22.9714L26.4353 15.6874L31.1697 22.3896L48.2722 24.5195L48.3523 41.6064L48.3474 41.5966L33.6677 41.9365C33.6677 41.9365 33.7617 37.9521 33.4499 34.8036C33.1382 31.6555 31.8445 29.6291 28.8054 29.6913C25.766 29.7537 24.7217 32.248 24.4412 34.2431C24.1606 36.2382 24.5343 39.1685 24.6902 40.6152C24.6601 40.6152 12.2647 40.6298 11.0212 40.6298C9.77886 40.6298 8.82121 40.3616 8.77612 38.9189C8.73604 37.6765 8.66186 35.6503 8.27612 33.8769C7.8904 32.1136 7.12369 29.7492 4.33374 29.749C1.65861 29.8241 1.03668 31.6027 1.6228 36.497C0.891564 35.921 0.717857 35.6613 0.468502 34.9911C0.220524 34.3247 0.0495257 31.9013 0.0476038 31.874C0.0476038 31.398 0.646237 31.0165 0.646237 31.0165L-0.0647009 22.8954C-0.109677 22.3646 0.019828 21.8286 0.310299 21.3779C1.06774 20.2056 2.60786 17.824 3.57495 16.3779C3.8255 15.939 3.93886 15.505 3.43823 15.2021C2.60498 14.6979 2.65187 13.7197 3.0476 13.7197H8.34741Z",
    fill: "#B9B2B4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3283_2562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5177 27.1677H-0.0386848V41.0149H40.5177V27.1677Z",
    fill: "url(#paint2_linear_3283_2562)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7699 51.2635L-1.50899 15.2483L21.5917 -2.03424L48.3895 33.981L23.7699 51.2635Z",
    fill: "url(#paint3_linear_3283_2562)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44908 23.8536H27.4944C27.4944 23.8536 24.8594 18.5935 22.7954 16.4745C21.1723 14.8113 17.5454 14.676 14.8903 14.671C12.2352 14.666 9.07912 14.7762 7.70148 14.8664C6.03328 14.9766 3.44331 19.1195 3.22289 19.6556C3.08262 19.9912 3.87414 21.5642 4.4803 22.6864C4.87105 23.4078 5.6275 23.8586 6.44908 23.8586V23.8536Z",
    fill: "#16A34A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6465 25.6323C64.1097 24.2446 57.9128 23.0373 47.2774 21.7999C35.2093 20.3922 47.9773 15.7592 47.1038 14.9934C46.2304 14.2276 42.4397 13.7231 36.1518 13.7231C29.8639 13.7231 18.9388 13.7231 18.9388 13.7231C20.1812 13.9285 22.9858 14.2955 24.7091 16.5398C25.9665 18.178 27.2991 20.4023 28.2108 22.0003C28.9573 23.3078 30.3382 24.2563 31.5823 24.7606C32.8265 25.265 34.3124 25.7263 35.9438 26.4496C37.5751 27.1728 38.4489 28.7197 38.2874 31.5436C38.1259 34.3676 36.7543 40.8828 36.5856 41.739L68.6735 41.5228C69.2897 41.5228 70.1631 40.4919 70.3435 39.9008C71.14 37.2808 71.9489 32.8868 71.9021 30.1592C71.8554 27.4315 69.6166 26.4059 67.6465 25.6323Z",
    fill: "#E7E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3283_2562",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 13,
    width: 54,
    height: 29
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6465 25.6323C64.1097 24.2446 57.9128 23.0373 47.2774 21.7999C35.2093 20.3922 47.9773 15.7592 47.1038 14.9934C46.2304 14.2276 42.4397 13.7231 36.1518 13.7231C29.8639 13.7231 18.9388 13.7231 18.9388 13.7231C20.1812 13.9285 22.9858 14.2955 24.7091 16.5398C25.9665 18.178 27.2991 20.4023 28.2108 22.0003C28.9573 23.3078 30.3382 24.2563 31.5823 24.7606C32.8265 25.265 34.3124 25.7263 35.9438 26.4496C37.5751 27.1728 38.4489 28.7197 38.2874 31.5436C38.1259 34.3676 36.7543 40.8828 36.5856 41.739L68.6735 41.5228C69.2897 41.5228 70.1631 40.4919 70.3435 39.9008C71.14 37.2808 71.9489 32.8868 71.9021 30.1592C71.8554 27.4315 69.6166 26.4059 67.6465 25.6323Z",
    fill: "#E7E5E5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3283_2562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.4228 21.351L22.3279 -3.52838L8.99625 28.3656L63.0911 53.245L76.4228 21.351Z",
    fill: "url(#paint4_linear_3283_2562)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M73.4764 34.8663H36.2555V39.8541H73.4764V34.8663Z",
    fill: "url(#paint5_linear_3283_2562)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4974 40.6765H8.33762V42.2545H26.4974V40.6765Z",
    fill: "#1D0C17"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0168 14.9168C40.8751 14.4709 24.7992 14.7063 24.7992 14.7063C27.1888 16.625 28.6867 19.741 29.7988 21.5445C30.6354 22.8971 32.1934 23.5834 34.7834 23.5834C37.3733 23.5834 59.3756 23.5283 59.3756 23.5283C57.6673 22.0705 47.3775 15.1622 47.0168 14.9168Z",
    fill: "#16A34A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3283_2562",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 14,
    width: 57,
    height: 10
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4803 22.6816C3.87414 21.5595 3.08262 19.9865 3.22289 19.6508C3.44331 19.1148 6.03328 14.9719 7.70148 14.8616C9.07912 14.7715 12.2352 14.6613 14.8903 14.6663C17.5454 14.6713 21.1723 14.8065 22.7954 16.4697C24.8594 18.5888 27.4944 23.8489 27.4944 23.8489H6.44908C5.6275 23.8489 4.87105 23.403 4.4803 22.6766V22.6816ZM47.0169 14.9168C40.8751 14.4709 24.7993 14.7063 24.7993 14.7063C27.1889 16.625 28.6867 19.741 29.7989 21.5445C30.6355 22.8971 32.1935 23.5834 34.7834 23.5834C37.3734 23.5834 59.3756 23.5283 59.3756 23.5283C57.6673 22.0705 47.3776 15.1622 47.0169 14.9168Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3283_2562)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.33447,
    y: 28.1924,
    width: 12.1546,
    height: 64.3416,
    transform: "rotate(-90 -3.33447 28.1924)",
    fill: "url(#paint6_linear_3283_2562)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0116195 21.9833C-0.0735439 22.2739 -0.113621 22.5795 -0.0885726 22.8851L0.410192 28.4408L1.64976 28.4407C1.46942 24.0373 1.48945 22.9652 0.00660976 21.9833H0.0116195Z",
    fill: "#5C4D53"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7135 42.2543H31.422V39.6994H70.4118L70.2815 40.0801C70.0962 40.6262 69.7956 41.1221 69.3948 41.5379L68.7135 42.2493V42.2543Z",
    fill: "#1D0C17"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4997 23.8435H24.0039C23.4177 23.8435 23.5352 20.9921 23.5352 20.9921H19.7377C19.7377 20.9921 18.9505 22.0535 18.9505 23.2076C18.9505 24.3617 19.9675 25.3897 19.9675 25.3897C19.9675 25.3897 24.0824 25.3897 25.7813 25.3897C27.4802 25.3897 27.4997 23.8435 27.4997 23.8435Z",
    fill: "#CFCBCC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.907 26.7302C68.1186 27.2211 67.3102 28.4916 67.7561 30.0345C68.0751 30.1006 70.5773 30.0813 71.8554 30.0657C71.9177 29.2864 71.7055 27.8724 69.907 26.7302Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4709 26.1388C45.359 26.2153 46.2787 26.3342 47.4123 26.509V26.5138C50.5431 26.9947 51.15 28.1351 50.5842 30.1037C48.8373 30.1688 47.1089 30.1589 45.7531 30.1095C45.7398 30.024 45.722 29.9101 45.6974 29.7746C45.6405 29.4599 45.551 29.0243 45.423 28.5412C45.2217 27.7812 44.916 26.8765 44.4709 26.1388ZM39.0011 26.0734C41.0469 26.0135 42.4234 26.0062 43.7599 26.0881C44.2802 26.7826 44.6437 27.7974 44.8791 28.6857C45.0023 29.1509 45.0878 29.5714 45.1427 29.8752C45.1567 29.9521 45.1677 30.0216 45.1779 30.0822C44.1205 30.0308 43.3725 29.9572 43.1545 29.8781C42.6681 29.7024 40.2835 28.102 39.0011 26.0734Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3283_2562",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 32,
    width: 6,
    height: 13
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4126 38.4694C26.4126 34.9395 27.5307 32.0842 28.9064 32.0842C30.2822 32.0842 31.4003 34.9455 31.4003 38.4694C31.4003 41.9934 30.2822 44.8547 28.9064 44.8547C27.5307 44.8547 26.4126 41.9934 26.4126 38.4694Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3283_2562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4003 38.4694C31.4003 41.9994 30.2822 44.8547 28.9064 44.8547C27.5307 44.8547 26.4126 41.9934 26.4126 38.4694C26.4126 34.9455 27.5307 32.0842 28.9064 32.0842C30.2822 32.0842 31.4003 34.9455 31.4003 38.4694Z",
    fill: "#746A6E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M27.6842 48.9328L36.3622 43.6221L30.2521 29.9757L21.574 35.2864L27.6842 48.9328Z",
    fill: "url(#paint7_linear_3283_2562)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M30.2616 38.6502C30.2616 41.3127 29.5248 43.4693 28.6128 43.4693C27.7008 43.4693 26.964 41.3127 26.964 38.6502C26.964 35.9877 27.7008 33.8311 28.6128 33.8311C29.5248 33.8311 30.2616 35.9877 30.2616 38.6502Z",
    fill: "#746A6E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3283_2562",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 32,
    width: 6,
    height: 13
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55725 38.4694C2.55725 34.9395 3.61596 32.0842 4.91862 32.0842C6.22128 32.0842 7.28 34.9455 7.28 38.4694C7.28 41.9934 6.22128 44.8547 4.91862 44.8547C3.61596 44.8547 2.55725 41.9934 2.55725 38.4694Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3283_2562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.28 38.4694C7.28 41.9994 6.22128 44.8547 4.91862 44.8547C3.61596 44.8547 2.55725 41.9934 2.55725 38.4694C2.55725 34.9455 3.61596 32.0842 4.91862 32.0842C6.22128 32.0842 7.28 34.9455 7.28 38.4694Z",
    fill: "#746A6E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M3.76127 48.9328L11.9783 43.6221L6.19279 29.9757L-2.02426 35.2864L3.76127 48.9328Z",
    fill: "url(#paint8_linear_3283_2562)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M6.20181 38.6502C6.20181 41.3127 5.50413 43.4693 4.64057 43.4693C3.77701 43.4693 3.07934 41.3127 3.07934 38.6502C3.07934 35.9877 3.77701 33.8311 4.64057 33.8311C5.50413 33.8311 6.20181 35.9877 6.20181 38.6502Z",
    fill: "#746A6E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3283_2562",
    x1: 61.054,
    y1: 47.1068,
    x2: 71.904,
    y2: 47.1068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1D0C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D0C17",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3283_2562",
    x1: 7.976,
    y1: 47.1069,
    x2: -0.0959473,
    y2: 47.1069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1D0C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D0C17",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3283_2562",
    x1: 20.2395,
    y1: 31.6099,
    x2: 20.2395,
    y2: 41.6264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#746A6E",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#746A6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3283_2562",
    x1: 35.3203,
    y1: 13.9803,
    x2: 10.7558,
    y2: 26.2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#746A6E",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#746A6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3283_2562",
    x1: 15.1112,
    y1: 12.1684,
    x2: 70.3078,
    y2: 37.5532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#CFCBCC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3283_2562",
    x1: 54.8637,
    y1: 36.4667,
    x2: 54.8637,
    y2: 40.0763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#746A6E",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746A6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3283_2562",
    x1: -3.33447,
    y1: 60.3632,
    x2: 8.82017,
    y2: 60.3632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115385,
    stopColor: "#42003B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913462,
    stopColor: "#42003B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3283_2562",
    x1: 25.4996,
    y1: 40.7051,
    x2: 34.7169,
    y2: 36.5781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CFCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CFCBCC",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#CFCBCC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3283_2562",
    x1: 1.69273,
    y1: 40.7051,
    x2: 10.5738,
    y2: 36.9399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CFCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CFCBCC",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#CFCBCC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3283_2562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 51,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg5MetuaaGreen);
export default __webpack_public_path__ + "static/media/img5_metuaa_green.c51dcab1691d1bba203726f8e1ba6b0f.svg";
export { ForwardRef as ReactComponent };